import React from 'react'
import { useMobileContext } from '../../Context/ContextProvider'
import Users from './Users'
import UsersMobile from './UsersMobile'
import { IntlShape } from 'react-intl';

interface Props {
    classes: {
        cardTitleWhite: string;
        formControl: string;
        cardCategoryWhite: string;
    };
    history: {
        goBack: () => void;
    };
    intl: IntlShape | undefined
}

const UsersWrapper:React.FC<Props> = (props) => {

    const isMobile = useMobileContext() 
    return isMobile ? <UsersMobile {...props} /> : <Users {...props} />
}
export default UsersWrapper